export default function getMerchantSessionUrl() {
  const fromEnv = process.env.VUE_APP_APPLE_PAY_MERCHANT_SESSION_URL
  if (fromEnv) {
    return fromEnv
  }
  return `https://${process.env.VUE_APP_BASE_DOMAIN_URL_PAYMENT_LINK}api/v1/step/apple-pay/merchant-session`
}
